import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSelectFeaturesLayerName } from "../../ducks/selectFeatures/selectors";
import { setSelectFeaturesLayerName } from "../../ducks/selectFeatures/selectFeatures";

export const useSelectFeaturesLayerName = (): [string, (name?: string) => void] => {
  const dispatch = useDispatch();
  const value = useSelector(getSelectFeaturesLayerName);

  const update = useCallback(
    (name: string) => {
      dispatch(setSelectFeaturesLayerName(name));
    },
    [dispatch],
  );

  return [value, update];
};
